"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRouterDom = require("react-router-dom");

var _core = require("@material-ui/core");

var _styles = require("@material-ui/styles");

var _CheckBoxOutlined = _interopRequireDefault(require("@material-ui/icons/CheckBoxOutlined"));

var _IndeterminateCheckBoxOutlined = _interopRequireDefault(require("@material-ui/icons/IndeterminateCheckBoxOutlined"));

var _Label = _interopRequireDefault(require("./dynamic-form/inputs/Label"));

var _Accordion = _interopRequireDefault(require("./dynamic-form/inputs/Accordion"));

var _Text = _interopRequireDefault(require("./dynamic-form/inputs/Text"));

var _Date = _interopRequireDefault(require("./dynamic-form/inputs/Date"));

var _Email = _interopRequireDefault(require("./dynamic-form/inputs/Email"));

var _Number = _interopRequireDefault(require("./dynamic-form/inputs/Number"));

var _Checkbox = _interopRequireDefault(require("./dynamic-form/inputs/Checkbox"));

var _Radio = _interopRequireDefault(require("./dynamic-form/inputs/Radio"));

var _Select = _interopRequireDefault(require("./dynamic-form/inputs/Select"));

var _Phone = _interopRequireDefault(require("./dynamic-form/inputs/Phone"));

var _Textarea = _interopRequireDefault(require("./dynamic-form/inputs/Textarea"));

var _Image = _interopRequireDefault(require("./dynamic-form/inputs/Image"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    circularProgress: {
      position: "absolute",
      top: "50%",
      left: "50%",
      marginTop: -12,
      marginLeft: -12
    },
    btn: {
      zIndex: 2,
      padding: "6px 16px"
    }
  };
});

var renderInput = function renderInput(field, value, readOnly, handleChange, edit, detail, isValid, loadingSelect, handleElements) {
  var storedAnswers = JSON.parse(localStorage.getItem("storedAnswers")) || [];

  var getItemValueFormated = function getItemValueFormated(value) {
    return value.toString().toLowerCase();
  };

  var isDisableByDependency = function isDisableByDependency(field) {
    var dependencyTarget = field.disableDependency;
    var dependencyTargetValue = field.disableDependencyExpectedValue ? field.disableDependencyExpectedValue.toLowerCase() : "";
    var dependencyTargetValues = dependencyTargetValue.split(",");
    var result = false;

    if (storedAnswers && storedAnswers.length) {
      result = storedAnswers.find(function (item) {
        return item.fieldId === dependencyTarget && dependencyTargetValues.includes(getItemValueFormated(item.value));
      }); //encuentra el componente del cual depende y ve si esta en negativo "0"
    }

    return !!result;
  };

  console.log("**************field.type.name: ", field.type.name);

  switch (field.type.name) {
    case "text":
      return /*#__PURE__*/React.createElement(_Text.default, {
        defaultValue: field.value,
        field: field,
        fieldId: field.uid,
        label: field.label,
        required: field.allowNull,
        isRequired: field.allowNull,
        readOnly: field.isPrimaryKey && edit || detail,
        handleChange: handleChange,
        type: field.type,
        autoComplete: "none",
        disable: isDisableByDependency(field)
      });

    case "date":
      return /*#__PURE__*/React.createElement(_Date.default, {
        defaultValue: field.value,
        field: field,
        fieldId: field.uid,
        label: field.label,
        required: field.allowNull,
        isRequired: field.allowNull,
        readOnly: field.isPrimaryKey && edit || detail,
        handleChange: handleChange,
        type: field.type
      });

    case "checkbox":
      return /*#__PURE__*/React.createElement(_Checkbox.default, {
        defaultValue: field.value ? field.value : false,
        field: field,
        fieldId: field.uid,
        required: field.required,
        readOnly: readOnly || detail,
        handleChange: handleChange
      });

    case "radio":
      return /*#__PURE__*/React.createElement(_Radio.default, {
        defaultValue: field.value ? field.value : false,
        field: field,
        fieldId: field.uid,
        label: field.label ? field.label : field.name,
        required: field.required,
        readOnly: readOnly || detail,
        handleChange: handleChange,
        isValid: isValid
      });

    case "select":
      return /*#__PURE__*/React.createElement(_Select.default, {
        defaultValue: field.value,
        field: field,
        fieldId: field.uid,
        label: field.label ? field.label : field.name,
        required: field.required,
        readOnly: readOnly || detail,
        handleChange: handleChange,
        isValid: isValid,
        loadingSelect: loadingSelect,
        handleElements: handleElements
      });

    case "number":
      return /*#__PURE__*/React.createElement(_Number.default, {
        defaultValue: field.value,
        field: field,
        fieldId: field.uid,
        label: field.label ? field.label : field.name,
        required: true,
        readOnly: field.isPrimaryKey && edit || detail,
        handleChange: handleChange,
        type: field.type
      });

    case "tel":
      return /*#__PURE__*/React.createElement(_Phone.default, {
        defaultValue: field.value,
        field: field,
        fieldId: field.uid,
        label: field.label,
        required: field.allowNull,
        isRequired: field.allowNull,
        readOnly: field.isPrimaryKey && edit || detail,
        handleChange: handleChange,
        type: field.type,
        autoComplete: "none"
      });

    case "email":
      return /*#__PURE__*/React.createElement(_Email.default, {
        defaultValue: field.value,
        field: field,
        fieldId: field.uid,
        label: field.label ? field.label : field.name,
        required: true,
        readOnly: field.isPrimaryKey && edit || detail,
        handleChange: handleChange,
        type: field.type
      });

    case "image":
      return /*#__PURE__*/React.createElement(_Image.default, {
        defaultValue: field.value,
        field: field,
        fieldId: field.uid,
        label: field.label ? field.label : field.name,
        required: true,
        readOnly: field.isPrimaryKey && edit || detail,
        handleChange: handleChange,
        type: field.type
      });

    default:
      return /*#__PURE__*/React.createElement(_Text.default, {
        defaultValue: field.value,
        field: field,
        fieldId: field.uid,
        label: field.label ? field.label : field.name,
        required: field.required,
        readOnly: field.isPrimaryKey && edit || detail,
        handleChange: handleChange,
        type: field.type
      });
  }
};

var RenderElement = function RenderElement(_ref) {
  var field = _ref.field,
      value = _ref.value,
      readOnly = _ref.readOnly,
      handleChangeInput = _ref.handleChangeInput,
      editMode = _ref.editMode,
      detail = _ref.detail,
      isValid = _ref.isValid,
      loading = _ref.loading,
      loadingSelect = _ref.loadingSelect,
      handleElements = _ref.handleElements,
      btnDisabled = _ref.btnDisabled,
      titleLabel = _ref.titleLabel,
      gridSize = _ref.gridSize;
  var classes = useStyles();

  switch (field.elementType) {
    case "label":
      return /*#__PURE__*/React.createElement(_Label.default, {
        field: field,
        label: field.label,
        titleLabel: titleLabel
      });

    case "accordion":
      return /*#__PURE__*/React.createElement(_Accordion.default, {
        field: field,
        label: field.label,
        gridSize: gridSize
      });

    case "input":
      return renderInput(field, value, readOnly, handleChangeInput, editMode, detail);

    case "date":
      return renderInput(field, value, readOnly, handleChangeInput, editMode, detail, isValid);

    case "textarea":
      return /*#__PURE__*/React.createElement(_Textarea.default, {
        field: field,
        handleChangeInput: handleChangeInput
      });

    case "button":
      {
        var containedStyle = {
          zIndex: 2,
          backgroundColor: field === null || field === void 0 ? void 0 : field.background,
          color: field === null || field === void 0 ? void 0 : field.color
        };
        var outlinedStyle = {
          zIndex: 2,
          borderColor: field === null || field === void 0 ? void 0 : field.background,
          backgroundColor: "transparent",
          color: field === null || field === void 0 ? void 0 : field.color
        };
        var styles = {
          outlined: outlinedStyle,
          contained: containedStyle
        };
        var defaultStyles = styles[field.variant];
        var style = !field.isActiveCustomStyles ? defaultStyles : JSON.parse(field.customStyles);
        return /*#__PURE__*/React.createElement(_core.Grid, {
          container: true,
          style: {
            display: "flex",
            justifyContent: field.align
          }
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            position: "relative",
            width: field.fullWidth ? "100%" : "auto"
          }
        }, /*#__PURE__*/React.createElement(_core.Button, {
          type: "submit",
          disabled: loading || btnDisabled,
          fullWidth: field.fullWidth,
          className: classes.btn,
          variant: field === null || field === void 0 ? void 0 : field.variant,
          color: field === null || field === void 0 ? void 0 : field.color,
          style: style
        }, field.label), loading && /*#__PURE__*/React.createElement(_core.CircularProgress, {
          size: 22,
          className: classes.circularProgress
        })));
      }

    case "checkbox":
      return renderInput(field, value, readOnly, handleChangeInput, editMode, detail);

    case "radio":
      return renderInput(field, value, readOnly, handleChangeInput, editMode, detail, isValid);

    case "select":
      return renderInput(field, value, readOnly, handleChangeInput, editMode, detail, isValid, loadingSelect, handleElements);

    case "image":
      return renderInput(field, value, readOnly, handleChangeInput, editMode, detail, isValid);

    default:
      // console.log("Elemento invalido");
      return;
  }
};

var RenderReadOnlyElement = function RenderReadOnlyElement(_ref2) {
  var field = _ref2.field,
      id = _ref2.id;

  switch (field.elementType) {
    case "checkbox":
      return /*#__PURE__*/React.createElement("div", null, field.value === "true" ? /*#__PURE__*/React.createElement(_CheckBoxOutlined.default, null) : /*#__PURE__*/React.createElement(_IndeterminateCheckBoxOutlined.default, null), /*#__PURE__*/React.createElement("b", null, field.label));

    case "button":
      return /*#__PURE__*/React.createElement("div", {
        style: {
          width: "100%",
          display: "flex",
          justifyContent: "flex-end"
        }
      }, /*#__PURE__*/React.createElement(_reactRouterDom.Link, {
        to: "/form/dnd/execute/".concat(id)
      }, /*#__PURE__*/React.createElement(_core.Button, {
        primary: true
      }, "Nuevo")));

    default:
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", null, field.label), /*#__PURE__*/React.createElement("h4", {
        style: {
          margin: ".5rem 0"
        }
      }, field.value), /*#__PURE__*/React.createElement("hr", null));
  }
};

var DynamicField = function DynamicField(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "field"
  }, props.readOnly ? /*#__PURE__*/React.createElement(RenderReadOnlyElement, {
    field: props.field,
    id: props.formId
  }) : /*#__PURE__*/React.createElement(RenderElement, {
    field: props.field,
    value: props.value,
    readOnly: props.readOnly,
    handleChangeInput: props.handleChangeInput,
    editMode: props.editMode,
    detail: props.detail,
    isValid: props.isValid,
    previewMode: props.previewMode,
    loading: props.loading,
    loadingSelect: props.loadingSelect,
    handleElements: props.handleElements,
    btnDisabled: props.btnDisabled,
    titleLabel: props.titleLabel,
    gridSize: props.gridSize
  }));
};

var _default = DynamicField;
exports.default = _default;